import Config from '@config';
import { initializeOrganizationsApi } from '@gasbi/shared/index';
import { useSelector } from 'react-redux';

import { organizationApi } from '@/features/organization/organizationApi';
import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

// The ГРМ card is created and edited only here, with the old BMS form (PO, 2026-10-27), over gdn-organizations: the
// routes and shapes of the BMS card. The roles stay the shared RBAC's, under organizations.
const organizations = initializeOrganizationsApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
  organizationsPath: 'gdn-organizations',
});

// The ГРМ list and the RBAC organization of a ГРМ (employee breadcrumbs) come from adminApi's organizations
// endpoints, which this API cannot invalidate, so a saved card refreshes them.
const refreshAdminOrganizations = (_: unknown, { dispatch, queryFulfilled }) =>
  queryFulfilled.then(
    () => dispatch(organizationApi.util.invalidateTags(['Organization'])),
    // A failed save keeps the form open with its errors: nothing changed.
    () => undefined,
  );

organizations.organizationsApi.enhanceEndpoints({
  endpoints: {
    createOrganization: { onQueryStarted: refreshAdminOrganizations },
    updateOrganizationById: { onQueryStarted: refreshAdminOrganizations },
  },
});

export const {
  organizationsApi,

  useGetReferenceBooksQuery,
  useGetOrganizationsGdnQuery,
  useGetOrganizationByIdQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationByIdMutation,
  useGetOrganizationDepartmentsQuery,
  useGetOrganizationEmployeePositionsQuery,
  useAddRepresentativeToOrganizationMutation,
  useRemoveRepresentativeFromOrganizationMutation,

  useGetOrganizationsInfiniteQuery,
  useGetOrganizationRolesInfiniteQuery,
} = organizations;

const getCachedOrganizationByIdSelector = cachedItemByIdSelector(
  'organizationsApi',
  'getOrganizations',
);

export const useGetCachedOrganizationByIdSelector = id =>
  useSelector(getCachedOrganizationByIdSelector(id));

const getCachedRoleByIdSelector = cachedItemByIdSelector(
  'organizationsApi',
  'getOrganizationRoles',
);

export const useGetCachedRoleByIdSelector = id =>
  useSelector(getCachedRoleByIdSelector(id));
